"use strict";

angular.module('impactx.address').controller('MultiAddressInputCtrl', MultiAddressInputCtrl);

MultiAddressInputCtrl.$inject = ['$scope'];

function MultiAddressInputCtrl($scope) {
    var types = {};
    var ctrl = this;

    ctrl.toggleReadOnly = function (type) {
        if (ctrl.checkIfCanToggle(type)) {
            switch (type) {
                case 'delivery':
                    $scope.readonlyDelivery.value = !$scope.readonlyDelivery.value;
                    break;
                case 'handover':
                    $scope.readonlyHandover.value = !$scope.readonlyHandover.value;
                    break;
                case 'invoice':
                    $scope.readonlyInvoice.value = !$scope.readonlyInvoice.value;
                    break;
                case 'contact':
                    $scope.readonlyContact.value = !$scope.readonlyContact.value;
                    break;
            }
        }
    };

    ctrl.checkIfCanToggle = function (type) {

        switch (type) {
            case 'delivery':
                return $scope.readonlyDelivery && !$scope.readonlyDelivery.readOnly;

            case 'handover':
                return $scope.readonlyHandover && !$scope.readonlyHandover.readOnly;

            case 'invoice':
                return $scope.readonlyInvoice && !$scope.readonlyInvoice.readOnly;

            case 'contact':
                return $scope.readonlyContact && !$scope.readonlyContact.readOnly;

            default:
                return false;
        }
    };

    $scope.getTypes = function () {
        types.delivery = !!$scope.deliveryAddress && !$scope.deliveryAddress.hide;
        types.handover = !!$scope.handoverAddress && !$scope.handoverAddress.hide;
        types.invoice = !!$scope.invoiceAddress && !$scope.invoiceAddress.hide;
        types.contact = !!$scope.contactAddress && !$scope.contactAddress.hide;
        return types;
    };

    var updateSpecific = function (adr, sourceType, targetType, hasTargetType, isTypeAvail, adrPopup) {
        var found, entries, i;
        if (sourceType !== targetType && isTypeAvail) {
            found = false;
            entries = adrPopup.entries;
            if (adr.addressId !== 0) // don't search for new addresses
            {
                for (i = 0; i < entries.length; i++) {
                    if (entries[i].addressId === adr.addressId) {
                        found = true;
                        break;
                    }
                }
            }
            if (hasTargetType) {
                if (!found) {
                    entries.push(adr);
                }
            }
            else if (adr.addressId !== 0) // don't remove addresses with id === 0
            {
                if (found) {
                    entries.splice(i, 1);
                }
                if (adrPopup.selected && adrPopup.selected.addressId === adr.addressId) {
                    delete adrPopup.selected;
                }
            }
        }
    };

    ctrl.updateOthers = function (adr, sourceType)  // adr is a AddressDTO
    {
        var typesAvail = $scope.getTypes();
        updateSpecific(adr, sourceType, 'delivery', impactX.isDefined(adr, "isDeliveryAddress.value"), typesAvail.delivery, $scope.deliveryAddress);
        updateSpecific(adr, sourceType, 'handover', impactX.isDefined(adr, "isHandoverAddress.value"), typesAvail.handover, $scope.handoverAddress);
        updateSpecific(adr, sourceType, 'invoice', impactX.isDefined(adr, "isInvoiceAddress.value"), typesAvail.invoice, $scope.invoiceAddress);
        updateSpecific(adr, sourceType, 'contact', impactX.isDefined(adr, "isContactAddress.value"), typesAvail.contact, $scope.contactAddress);
    };
}
